.inbox-sidebar-thread-list {
    width: 200px;
    flex-shrink: 0;
    overflow: auto;
    height: 100%;
    border-right: 1px solid var(--off-white-dk);
}
